import { Box, Typography } from "@mui/material";
import { useConfig } from "../../../Settings/useConfig";
import useLocationInfo, { LocationInfoProps } from "../hooks/useLocationInfo";
import { formatFullTime, formatFullWeekday, formatShortDateWithWeekday } from "../../Common/Locale/formatUtils";
import { formatLatLong } from "../../Common/Units/utils";


const LocationInfo = (props: LocationInfoProps): JSX.Element => {

    const config = useConfig();
    const info = useLocationInfo(props);

    return (
        <>
        {!info.hasLocation && 
            <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                <Typography fontSize="large" component="h2">No location information available</Typography>
            </Box>
        }

        {!!info.hasLocation &&
            <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                <Typography fontSize="large" component="h2">Ordnance Survey National Grid</Typography>

            {!info.osGridRef && <Typography fontSize={60}>Outside valid range</Typography>}
            {!!info.osGridRef && 
                <>
                    <Typography fontSize={50}>{info.osGridRef.prefix}</Typography>
                    <Typography fontSize={50}>{info.osGridRef.ea}</Typography>
                    <Typography fontSize={50}>{info.osGridRef.no}</Typography>
                </>
            }

                <Typography fontSize="large" component="h2" marginTop={4}>Lat, Long</Typography>
                <Typography fontSize={25}>{formatLatLong(info.location!.point)}</Typography>
            </Box>
        }

            <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" marginTop={4}>
                <Typography fontSize={50}>{formatFullWeekday(info.date, config.locale)}</Typography>
                <Typography fontSize={50}>{formatShortDateWithWeekday(info.date, config.locale)}</Typography>
                <Typography fontSize={50}>{formatFullTime(info.date, config.locale)}</Typography>
            </Box>
        </>
    );
};

export default LocationInfo;